import React, { useState } from 'react';
import { Button, Popover, Tooltip } from 'antd';
import { useHouseRegistrationTypes } from '../../api/registrationTypesQuery';
import styles from './ActiveComponent.module.scss';

import useChangeTemplateModalVisible from '../../../../../hooks/useChangeTemplateModalVisible';
import { ReactComponent as TemplatePopover } from '../../../../../../../resource/TemplatePopover.svg';
import { useSelector } from 'react-redux';

const PopoverContent = ({ onClick, houseData }) => {
  const { open } = useChangeTemplateModalVisible();

  const { ChangeHouseRegistrationType } = useSelector(
    (state) => state.authentication.userInfo
  );

  const isDisabledRegistration = !ChangeHouseRegistrationType;

  return (
    <ul className={styles.listType}>
      <Tooltip
        title={
          isDisabledRegistration
            ? 'У вас нет права для изменения режима регистрации'
            : ''
        }
      >
        <Button
          key={1}
          disabled={isDisabledRegistration}
          style={{
            padding: 0,
            color: isDisabledRegistration ? 'gray' : 'black',
          }}
          onClick={() => {
            open(houseData);
            onClick();
          }}
          type="link"
        >
          Изменить режим регистрации
        </Button>
      </Tooltip>
    </ul>
  );
};

const ActiveComponent = ({ houseData }) => {
  const [visible, setVisible] = useState(false);

  useHouseRegistrationTypes({
    staleTime: Infinity,
  });

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Popover
        placement="right"
        content={
          <PopoverContent
            currentTypeId={houseData.registrationType?.id}
            onClick={() => {
              setVisible(false);
            }}
            houseData={houseData}
          />
        }
        trigger="click"
        visible={visible}
        onVisibleChange={(v) => setVisible(v)}
      >
        <TemplatePopover />
      </Popover>
    </div>
  );
};

export default ActiveComponent;
